<script setup>
import {onMounted, ref, watch} from "vue";
import needsService from "@/services/needs.service";
import {useRoute} from "vue2-helpers/vue-router";

const route = useRoute();

const step = ref(1);
const show = ref(false);
const alwaysShow = route.query.onboarding;

watch(step, value => {
    if (value > 3) {
        show.value = false;
    }

    if (!alwaysShow) {
        saveStep();
    }
});

onMounted(() => {
    if (alwaysShow) {
        show.value = true;
    } else {
        getLastStep();
    }
});

async function getLastStep() {
    const {data} = await needsService.getOnboardingStep();
    step.value = data ?? 0;

    if (step.value <= 3) {
        show.value = true;
    }
}

async function saveStep() {
    await needsService.saveOnboardingStep(step.value);
}
</script>

<template>
    <div id="needs-onboarding" v-if="show">
        <div style="display: flex; justify-content: center; align-items: center; height: 100%">
            Onboarding Widget
            <br>
            <template>
                {{step}}
            </template>

            <a v-if="step > 1" @click="step--">
                Back
            </a>

            <a @click="step++">
                <template v-if="step === 3">
                    Get Started
                </template>

                <template v-else>
                    Next
                </template>
            </a>
        </div>
    </div>
</template>

<style scoped>
#needs-onboarding {
    position: fixed;
    x: 0;
    y: 0;
    width: 100%;
    height: 100%;
    z-index: 100;
    background: #fff;
}
</style>
